import documentIcon from 'assets/icons/document.svg';
import Card from 'components/UI/Card';

const AccountStatements = () => {
  const renderAccountStatements = () => {
    const documents = [
      { title: 'Estados de cuenta', description: 'Breve descripción del Estados de cuenta' },
      { title: 'Estados de cuenta', description: 'Breve descripción del Estados de cuenta' },
      { title: 'Estados de cuenta', description: 'Breve descripción del Estados de cuenta' },
    ];
    return documents.map((document) => {
      return (
        <Card
          key={document.title}
          title={document.title}
          titleClassName='text-sm'
          description={document.description}
          descriptionClassName='text-xs'
          image={documentIcon}
          showAccessIcon
        />
      );
    });
  };

  return (
    <div className='account-statements'>
      {renderAccountStatements()}
    </div>
  );
};

export default AccountStatements;
